import { baseTemplateParams } from '../shared/baseParams.js'
import { RESORT_DISCOVERY_DEFAULTS } from '../shared/resortDiscoveryDefaults.js'

export const defaultTemplateParams = {
  ...baseTemplateParams,
  ...RESORT_DISCOVERY_DEFAULTS,
  richtextFields: {
    ...baseTemplateParams.richtextFields,
    ...RESORT_DISCOVERY_DEFAULTS.richtextFields
  },
  selectedTemplate: 'resortDiscovery',
  shellTemplateKey: 'resortDiscovery'
}

export default defaultTemplateParams
